import { render } from "./NewResellerPage.vue?vue&type=template&id=a503f81a"
import script from "./NewResellerPage.vue?vue&type=script&lang=js"
export * from "./NewResellerPage.vue?vue&type=script&lang=js"

import "./NewResellerPage.vue?vue&type=style&index=0&id=a503f81a&lang=css"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__